export default __webpack_public_path__ + "static/media/happy_kid.8144e2ba.png";